import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Questionnaire from './pages/Questionnaire';
import SignIn from './pages/Login';
import { AuthProvider } from './contexts/AuthContext'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import PasswordPage from './pages/PasswordPage';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/small_components/PrivateRoute';


function App() {
  const [isLoggedIn, setIsloggedIn] = useState(false)
  const [user, setUser] = useState({});

  const correctPassword = "eterna-life"

  useEffect(() => {
    document.title = "EternaDNA Questionnaire"
  }, []);

  const theme = createTheme({
    typography: {
      h1: {
        fontSize: 56,
        fontWeight: 500,
        marginBottom: 32
      }
    },
    palette: {
      primary: {
        main: "#ddb567"
      },
      secondary: {
        main: "#333333"
      }
    }
  })

  function AuthenticateQuestionnaire() {
    if (isLoggedIn === true) {
      return (
        <Questionnaire />
      )
    }
    else {
      return (
        <PasswordPage
          theme={theme}
          correctPassword={correctPassword}
          setIsloggedIn={setIsloggedIn}
        />
      )
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider user={user} setUser={setUser}>
          <Routes>
            <Route path="/" element={<AuthenticateQuestionnaire />} />
            <Route path="/login" element={<SignIn user={user}/>} />
            <Route element={<PrivateRoute user={user} redirectPath="/login" />}>
              <Route path="dashboard" element = {<Dashboard />} />
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  )
}

export default App;
